import { render } from "./loader.vue?vue&type=template&id=4deba93a&scoped=true&lang=html"
import script from "./loader.vue?vue&type=script&lang=js"
export * from "./loader.vue?vue&type=script&lang=js"

import "./loader.vue?vue&type=style&index=0&id=4deba93a&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4deba93a"]])

export default __exports__